import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import ru from '@/locales/ru.json'
import en from '@/locales/en.json'
import consentRu from '@/locales/ru/consent.json'
import legalRu from '@/locales/ru/legal.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru, consent: consentRu, legal: legalRu },
      en: { translation: en },
    },
    ns: ['translation', 'consent', 'legal'],
    defaultNS: 'translation',
    fallbackLng: 'ru',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export { i18n }
